import React, {createContext, FC, useContext, useState} from "react";
import {WithChildren} from "../../../../_metronic/helpers";

type DynamicComponentsStateContextProps = {
    setActiveTab: (componentId: string, activeTab: string | null) => void
    getActiveTab: (componentId: string) => string | null
    setActivePage: (componentId: string, activePage: number | null) => void
    getActivePage: (componentId: string) => number | null
}

const initialState = {
    setActiveTab: (componentId: string, activeTab: string | null) => {
    },
    getActiveTab: (componentId: string) => null,
    setActivePage: (componentId: string, activePage: number | null) => {
    },
    getActivePage: (componentId: string) => null
}

const DynamicComponentsStateContext = createContext<DynamicComponentsStateContextProps>(initialState)

const useDynamicComponentsState = () => {
    return useContext(DynamicComponentsStateContext)
}

const DynamicComponentsStateProvider: FC<WithChildren> = ({children}) => {
    const [activeTabs, setActiveTabs] = useState<{ [key: string]: any }>({})
    const [activePages, setActivePages] = useState<{ [key: string]: number | null }>({})

    const setActiveTab = (componentId: string, activeTab: string | null) => {
        const merge: { [key: string]: string | null } = {}
        merge[componentId] = activeTab

        setActiveTabs({...activeTabs, ...merge})
    }

    const getActiveTab = (componentId: string) => {
        return activeTabs[componentId] ?? null
    }

    const setActivePage = (componentId: string, activePage: number | null) => {
        const merge: { [key: string]: number | null } = {}
        merge[componentId] = activePage

        setActivePages({...activePages, ...merge})
    }

    const getActivePage = (componentId: string) => {
        return activePages[componentId] ?? null
    }

    return (
        <DynamicComponentsStateContext.Provider
            value={
                {setActiveTab, getActiveTab, setActivePage, getActivePage}
            }
        >
            {children}
        </DynamicComponentsStateContext.Provider>
    )
}

export {DynamicComponentsStateProvider, useDynamicComponentsState}